import React from 'react';
import { Box } from '@wix/design-system';
import s from './CarouselStudioBranding.module.scss';
import StudioLogo from '../../../../assets/images/StudioLogo';
const CarouselStudioBranding = _ref => {
  let {
    isMobileView
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    className: isMobileView ? s.logoBackgroundMobile : s.logoBackground,
    width: "73px",
    height: "19px",
    verticalAlign: "middle",
    align: "center"
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(StudioLogo, null)));
};
export default CarouselStudioBranding;
//# sourceMappingURL=CarouselStudioBranding.js.map